module.exports = __webpack_public_path__ + "img/frame (16).beb4ea88.jpg";